export default [
  {
    q: 'Can I file my self-employment income with my W-2 income?',
    a: '“Yes! You should file all of your sources of income on the same tax return. All you’ll need to do is report which types of income you have, and how much you made of that type.”',
    author: {
      name: 'Tade A.',
      title: 'Enrolled Agent with the IRS',
      img: 'https://images.contentful.com/heg7gyzix6dq/6disJ6ld1SWCCWUU00IKSG/5733590a08f7c9392250bb52c59c7044/tade_2x.png',
    },
  },
  {
    q: 'How do I know if I can deduct an expense?',
    a: '“If you pay for something that is considered “ordinary and necessary” to run your business, then it’s deductible. <br />Questions you can ask yourself are: 1) Do I need this to run my business? or 2) Would this improve my ability to run my business?”',
    author: {
      name: 'Tade A.',
      title: 'Enrolled Agent with the IRS',
      img: 'https://images.contentful.com/heg7gyzix6dq/6disJ6ld1SWCCWUU00IKSG/5733590a08f7c9392250bb52c59c7044/tade_2x.png',
    },
  },
  {
    q: 'Should I take the standard mileage deduction?',
    a: '“Probably! The standard mileage rate for 2017 is 53.5 cents per mile, and it’s calculated to include the average cost of gas, car payments, car insurance, maintenance, and other vehicle expenses. It’s pretty generous, so if you drive upwards of 5,000 miles per year for work, and don’t have a gas-inefficient car, then you’ll probably get a larger tax deduction than if you deducted every gas, car payment, and maintenance receipt.”',
    author: {
      name: 'Tade A.',
      title: 'Enrolled Agent with the IRS',
      img: 'https://images.contentful.com/heg7gyzix6dq/6disJ6ld1SWCCWUU00IKSG/5733590a08f7c9392250bb52c59c7044/tade_2x.png',
    },
  },
  {
    q: 'How do I report a 1099?',
    a: '“You’ll report your self-employment income on a form called the Schedule C. It includes information on your income and expenses, and you’ll attach this to the rest of your tax return. This ensures that your income is taxed properly!”',
    author: {
      name: 'Tade A.',
      title: 'Enrolled Agent with the IRS',
      img: 'https://images.contentful.com/heg7gyzix6dq/6disJ6ld1SWCCWUU00IKSG/5733590a08f7c9392250bb52c59c7044/tade_2x.png',
    },
  },
  {
    q: 'Should I keep receipts from my business expenses?',
    a: '“Absolutely! You’ll want to keep as much information on your business as possible. Documentation like receipts, invoices, and bank statements are great ways to back up the income and expenses that you report on your tax return. You can store photos of your receipts in Stride Tax!”',
    author: {
      name: 'Tade A.',
      title: 'Enrolled Agent with the IRS',
      img: 'https://images.contentful.com/heg7gyzix6dq/6disJ6ld1SWCCWUU00IKSG/5733590a08f7c9392250bb52c59c7044/tade_2x.png',
    },
  },
];
